/* src/app/global/components/global-login/global-login.component.scss */
:host {
  background: center/cover no-repeat;
}
.cw-login-error {
  font-size: 1.3rem;
  height: 4rem;
}
.cw-login-input {
  border: 1px solid var(--color-primary-lighter);
  font-size: 1.4rem;
  height: 35px;
  padding-left: 35px;
  margin-bottom: 10px;
  width: 100%;
}
.cw-login-input:focus {
  border-color: var(--color-primary);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px rgba(144, 144, 144, 0.4);
  outline: none;
}
.cw-login-icon {
  font-size: 2.5rem;
  height: 35px;
  line-height: 3.5rem;
  position: absolute;
  text-align: center;
  width: 35px;
}
.cw-login-forgot {
  text-align: right;
}
.cw-password-wrapper {
  display: flex;
  align-items: center;
  height: 35px;
  border: 1px solid var(--color-primary-lighter);
  margin-bottom: 10px;
}
.cw-password-wrapper:focus-within {
  border-color: var(--color-primary);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px rgba(144, 144, 144, 0.4);
}
.cw-password-wrapper .cw-login-input {
  flex: 1;
  height: 100%;
  border: none;
  margin-bottom: 0;
  box-shadow: none;
}
.cw-password-wrapper .cw-login-input:focus {
  border: none;
  box-shadow: none;
}
.cw-password-toggle {
  flex-shrink: 0;
  width: 35px;
  height: 100%;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-primary-lighter);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cw-password-toggle:hover {
  color: var(--color-primary);
  background-color: rgba(0, 0, 0, 0.04);
}
.cw-login-button {
  margin-bottom: 10px;
  text-transform: uppercase;
  width: 100%;
}
.image-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.image-container img {
  width: 24px;
  height: 24px;
}
.image-container span {
  margin: 0;
}
/*# sourceMappingURL=global-login.component.css.map */
